import { PaymentsWorkspace } from '@/components/payments/payments-workspace'

export function AdminPayments() {
  return <PaymentsWorkspace billingPath="/admin/billing" />
}
